export const AUTH_REALM_CONFIG = 'Cinch-User-Account-DB';
export const AUTH_RESPONSE_TYPE = 'token id_token';
export const AUTH_LOGIN_REQUIRED_ERROR = 'login_required';